import React from 'react';
import PropTypes from 'prop-types';

import Diff from "./Diff";
import { useReplaceImageTags } from "../utils/CustomHooks";

function GSuiteContent(props) {
	let {className} = props,
		patch = useReplaceImageTags(props.patch);

	return (
		<div className={className}>
			<Diff patch={patch} />
		</div>
	);
}

GSuiteContent.propTypes = {
	patch: PropTypes.string,
	className: PropTypes.string
};

export default GSuiteContent;